export const NetsparkerVerification = () => {
    if (!import.meta.env.VITE_NETSPARKER_VERIFICATION_CODE) {
        return null;
    }

    return (
        <meta
            content={import.meta.env.VITE_NETSPARKER_VERIFICATION_CODE}
            name="netsparkerenterprise-site-verification"
        />
    );
};
